import EventContext from "./event-context";
import { useState, useEffect } from "react";

sessionStorage.getItem("event")


const EventProvider = props => {
    const [selected, setSelected] = useState(null)
    const [selectedid, setSelectedid] = useState("")

    // Initialize settings - load from sesion if present
    useEffect(() => {
        const event_string = sessionStorage.getItem("event")
        if (event_string !== "") {
            const event = JSON.parse(event_string)
            if (event !== null) {
                setSelected(event)
                setSelectedid(event.eventid)
            }
        }
    }, []);

    const clearEventInHandler = () => {
        console.log("Clearing Event")
        setSelected({});
        setSelectedid("");
        sessionStorage.setItem("event", "") 
    };
    
     const setEventInHandler = (event) => {
        console.log("Set in context: " + event.eventid)
        setSelected(event);
        setSelectedid(event.eventid)
        sessionStorage.setItem("event", JSON.stringify(event))
    };

    const eventContext = {
        event: selected,
        eventId: selectedid,
        clearEvent: clearEventInHandler,
        setEvent: setEventInHandler
    }

    return <EventContext.Provider value={eventContext}>
        {props.children}
    </EventContext.Provider>
};

export default EventProvider